<template>
	<ThePageLoading v-if="isPageLoading && !isDashboard"></ThePageLoading>
	
	<div class="page-container card col-md-8" :class="{'col-md-12': isDashboard}" v-if="!isPageLoading">
		<ThePageHeader @export-pdf-event="exportPdf" :renderExportReport="!isLoading && pageError == '' && journalReport != null && journalReport.contents != null && journalReport.contents.length > 0" :isExporting="isExporting" v-if="!isDashboard"></ThePageHeader>
		
		<div class="row p-3" v-if="pageError == ''">
			<div class="col-md-5 d-flex align-items-center">
				<Button type="button" class="p-button-sm" label="Generate" @click="generateReport" :disabled="pageError != ''" />
				<span class="p-1"></span>
				<Button class="p-button-sm p-button-secondary" label="Back" @click="back" v-if="!isDashboard" />
			</div>
		</div>
		
		<TheTabViewLoading v-if="isLoading"></TheTabViewLoading>
		
		<div class="row p-3" v-if="pageError == ''">			
			<div class="col-md-12 p-3" v-if="journalReport != null && journalReport.contents != null && journalReport.contents.length > 0">
				<div class="row p-0 mt-0">
					<label style="font-weight: bold;">{{ journalReport.header.groupName }}</label>
				</div>
                                
				<div class="row m-0 p-0">
					<div class="col p-0">
						<label style="font-weight: bold;">Consolidation Journal Listing (Sorted by {{ Object.keys(journalReport.contents[0].details[0]).length == 3 ? 'account code' : 'Journal ID' }})</label>
					</div>
                                    
					<div class="col p-0">
						<label style="font-weight: bold;">Period ended {{ journalReport.header.date }}</label>
					</div>
				</div>
                                
				<table class="w-100 mt-3">
					<thead>
						<tr class="border border-dark">
							<th class="p-1" v-for="(header, headerIndex) in Object.keys(journalReport.contents[0].details[0])" :key="headerIndex" :style="(header == 'Accts code/JR ID' || header == 'Jr ID/Acct Code' ? 'width: 15%;' : '')+ (header == 'Accounts' ? 'width: 65%;' : '') + (header == 'Descriptions' ? 'width: 75%' : '') + (headerIndex > 1 ? 'width: 10%; text-align: right;' : '')">{{ header }}</th>
						</tr>
					</thead>
                                    
					<tbody v-for="(content, contentIndex) in journalReport.contents" :key="contentIndex">
						<tr>
							<td colspan="2" class="pt-4" style="font-weight: bold;">{{ content.subtitle }}</td>
						</tr>
                
						<tr v-for="(account, accountIndex) in content.details" :key="accountIndex">
							<td v-for="(account_key, account_key_index) in Object.keys(account)" :key="account_key_index" :style="((accountIndex == content.details.length-1 && account_key_index > 1) ? ('border-bottom: 4px double black;') : '') + ((account[Object.keys(account)[0]] == 'Total' && account_key_index > 1) ? 'border-top: 1px solid black;' : '' ) + (account_key_index > 1 ? 'text-align: right' : '')">{{ account[account_key] }}</td>
						</tr>
					</tbody>
				</table>

				<div class="row mt-4 p-0">
					<label>Summary:-</label>
				</div>
                                
				<div class="row p-0">
					<label>{{ journalReport.summary.total }}</label>
				</div>
				
				<div class="row p-0">
					<label>(Retrieved on {{ formatToReportDateTime(journalReport.summary.retrievedDate) }})</label>
				</div>
			</div>
			
			<div class="col-md-12 p-4" v-if="!isLoading && journalReport != null && journalReport.contents != null && journalReport.contents.length == 0">
				<div class="error-no-record">
					<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
					<h6><span>No Record Found</span></h6>
				</div>
			</div>
		</div>
		
		<ThePageError @back-event="back" :pageError="pageError" v-if="pageError != ''"></ThePageError>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import store from "@/store";
    import { useRoute } from "vue-router";
	
    import reportApi from "@/api/reporting/report-api";
    import dateUtilsMixin from "@/mixin/utils/date-utils";
	import roleMixin from "@/mixin/role";
	
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	import TheTabViewLoading from "@/components/TheTabViewLoading.vue";

	import useVuelidate from "@vuelidate/core"
	import { required, minLength, helpers } from "@vuelidate/validators"
	
	export default defineComponent({
        mixins:[dateUtilsMixin, roleMixin],
		components: {
			ThePageHeader,
			ThePageLoading,
			ThePageError,
			TheTabViewLoading,
		},
        data() {
            return {
                pageError: (store.getters.error == undefined ? '' : store.getters.error),
                report: {name: '', isClosed: false},
                reportConfigurationModel: {reportInfoModel: {reportName: null as any}, reportSystemFilterModel: {systemFilterModels: []}, reportUserFilterModel: {userFilterModels: [{isStatic: false, selectionType: '', defaultValue: '', value: null as any, isAllowAll: false, dataType: '', startDate: null as any, endDate: null as any, isHide: false}]}, reportChartModel: {chartType: '', chartFieldModels: [], formattingModel: {showStatistic: false, showDifferentColor: false, showSubTotal: false, showGrandTotal: false}}},
				isLoading: false,
				isPageLoading: true,
                journalReport: {},
                session: store.getters.getSession,
				routeQueries: null as any,
				isExporting: false,
            }
        },
        props: {
			identifier: {
				type: String,
				required: false
			},
			reportId: {
				type: String,
				required: false
			},
			isDashboard: {
				type: Boolean,
				required: false
			}
		},
        mounted: function () {
            if (this.pageError == '') {
				if (this.identifier != null && this.reportId != null) {
					this.isPageLoading = true;
					reportApi.reportView(this.identifier, this.reportId)
						.then(response => {
							this.report = response.data.report;
							this.reportConfigurationModel = response.data.reportConfigurationModel;
							
							this.isPageLoading = false;
							
							this.reset();
						})
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						})
				}
			}
        },
        methods: {
			reset() {
				this.journalReport = {};
				
				this.generateReport();
			},
			generateReport() {
				this.isLoading = true;
					
				if (!this.pageError) {
					reportApi.reportGenerate(this.identifier, this.reportId, {reportConfigurationModel: this.reportConfigurationModel})
						.then(response => {
							this.journalReport = response.data;
							this.isLoading = false;
						})
						.catch(error => {
							this.isLoading = false;
							this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						})
				}
					
				else {
					this.isLoading = false;
				}
			},
			back() {
                this.$router.push('/reporting/report');
            },
            exportPdf() {
				this.isExporting = true;

				reportApi.reportExport(this.identifier, this.reportId, {reportConfigurationModel: this.reportConfigurationModel})
					.then(response => {
						this.isExporting = false;
					})
					.catch(error => {
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
            }
        },
        setup() {
			return {v$: useVuelidate()}
		},
		validations() {
			return {
				reportConfigurationModel: {
					reportUserFilterModel: {
						userFilterModels: {
							$each: helpers.forEach({
								value: {
									required
								}
							})
						},
					}
				}
			}
		}
	});
</script>